<app-modal
  [visible]="visible"
  [header]="''"
  [width]="'500px'"
  [showFooter]="false"
  [closable]="false"
  (visibleChange)="onClose()"
>
  <div class="login-modal-content">
    <!-- Leaf Image - Bottom Right -->
    <div class="login-modal--leaf-image">
      <img src="/assets-leaf.png" alt="" class="login-modal--leaf" />
    </div>
    
    <div class="login-modal--icon-wrapper">
      <svg class="login-modal--icon" width="64" height="64" viewBox="0 0 24 24" fill="none">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    
    <h3 class="login-modal--title">Please Login to Continue</h3>
    <p class="login-modal--message">
      You need to be logged in to access this feature. Please login with your account to proceed.
    </p>
    
    <div class="login-modal--actions">
      <button class="login-modal--btn login-modal--btn-login" (click)="onLogin()">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <polyline points="10 17 15 12 10 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <line x1="15" y1="12" x2="3" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Login</span>
      </button>
      <button class="login-modal--btn login-modal--btn-cancel" (click)="onClose()">
        Cancel
      </button>
    </div>
  </div>
</app-modal>
